import { h, Host } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";
export class TableRowNeo {
    constructor() {
        this.loading = undefined;
        this.selectable = undefined;
        this.cells = undefined;
        this.head = undefined;
    }
    host;
    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }
    /**
     * Cell count change event
     * @internal
     */
    cellCountChange;
    /**
     * Head cell count change event
     * @internal
     */
    headCellCountChange;
    handleSlotChange(e) {
        if (!e) {
            return;
        }
        this.cells = e.assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.host.style.setProperty("--ux-cell-count", this.cells.length.toString());
        if (this.head) {
            this.headCellCountChange.emit(this.cells.length);
        }
        else {
            this.cellCountChange.emit(this.cells.length);
        }
        for (const [index, cell] of this.cells.entries()) {
            cell.index = index;
        }
    }
    clearSortFields(event) {
        this.cells.forEach((cell) => {
            if (cell.isEqualNode(event.target)) {
                return;
            }
            cell.removeAttribute("sorted");
        });
    }
    setLoadingState(enabled = this.loading) {
        const cells = Array.from(this.host.querySelectorAll("ux-table-cell-neo"));
        const headCells = Array.from(this.host.querySelectorAll("ux-table-cell-neo[head]"));
        for (const cell of [...cells, ...headCells]) {
            cell.loading = enabled;
        }
    }
    render() {
        return (h(Host, { key: 'a80e868009714edd0e0894c349a16d9218d43306', role: "row" }, this.selectable ? h("ux-table-ux-table-cell-neo", null, " ") : null, h("slot", { key: '8719ab86d99e718ee4093cbbc7acf9ba549d3f06', onSlotchange: (e) => this.handleSlotChange(e.target) })));
    }
    static get is() { return "ux-table-row-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-row-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-row-neo.css"]
        };
    }
    static get properties() {
        return {
            "loading": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set table row to loading state. All child cells will be loading."
                },
                "attribute": "loading",
                "reflect": true
            },
            "selectable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "selectable",
                "reflect": false
            },
            "head": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, the row will be rendered as a header row."
                },
                "attribute": "head",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "cells": {}
        };
    }
    static get events() {
        return [{
                "method": "cellCountChange",
                "name": "cellCountChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": undefined
                        }],
                    "text": "Cell count change event"
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }, {
                "method": "headCellCountChange",
                "name": "headCellCountChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": undefined
                        }],
                    "text": "Head cell count change event"
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
    static get watchers() {
        return [{
                "propName": "loading",
                "methodName": "setLoadingState"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxSort",
                "method": "clearSortFields",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=table-row-neo.js.map
